module.exports = __webpack_public_path__ + "static/ebook_desktop-f8b2cf7d929ee2bb08335b29b67f32ed.jpg";